import { ITOServiceException as __BaseException } from "../models/ITOServiceException";
import { BRASSDependencyException, BadRequestException, CatalogicalDependencyException, ExpectationFailedException, ForbiddenException, InternalServerException, NotFoundException, OUIDependencyException, ThrottlingError, UnauthorizedException, } from "../models/models_0";
import { loadRestJsonErrorCode, parseJsonBody as parseBody, parseJsonErrorBody as parseErrorBody, } from "@aws-sdk/core";
import { requestBuilder as rb } from "@smithy/core";
import { decorateServiceException as __decorateServiceException, expectBoolean as __expectBoolean, expectInt32 as __expectInt32, expectNonNull as __expectNonNull, expectObject as __expectObject, expectString as __expectString, limitedParseDouble as __limitedParseDouble, parseRfc3339DateTimeWithOffset as __parseRfc3339DateTimeWithOffset, serializeDateTime as __serializeDateTime, serializeFloat as __serializeFloat, strictParseInt32 as __strictParseInt32, _json, collectBody, convertMap, map, take, withBaseException, } from "@smithy/smithy-client";
export const se_AddOrderLabelCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/order_labels/{orderId+}");
    b.p('orderId', () => input.orderId, '{orderId+}', true);
    let body;
    body = JSON.stringify(take(input, {
        'description': [],
        'label': [],
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_AddSubLineItemCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/orders/{orderId}/items/{itemId}/sublines");
    b.p('orderId', () => input.orderId, '{orderId}', false);
    b.p('itemId', () => input.itemId, '{itemId}', false);
    const query = map({
        [_dR]: [() => input.dryRun !== void 0, () => (input[_dR].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'subLineItem': _ => se_OrderSubLineItem(_, context),
    }));
    b.m("POST")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_BulkProcessSubLinesCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/sublines");
    let body;
    body = JSON.stringify(take(input, {
        'listOfSubLinePerOrderItems': _ => se_ListOfSubLinePerOrderItems(_, context),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_CutTicketCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/ticket");
    const query = map({
        [_dR]: [() => input.dryRun !== void 0, () => (input[_dR].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'comment': [],
        'orderId': [],
        'relatedTaxonomyId': [],
        'type': [],
    }));
    b.m("POST")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_DeleteCommentCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/comments/{taxonomyId+}");
    b.p('taxonomyId', () => input.taxonomyId, '{taxonomyId+}', true);
    let body;
    b.m("DELETE")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_DeleteItemAttachmentCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/attachment/{attachmentId+}");
    b.p('attachmentId', () => input.attachmentId, '{attachmentId+}', true);
    let body;
    b.m("DELETE")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_DeleteNoteCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/notes/{taxonomyId+}");
    b.p('taxonomyId', () => input.taxonomyId, '{taxonomyId+}', true);
    let body;
    b.m("DELETE")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_DeleteSubLineItemCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/orders/{orderId}/items/{itemId}/sublines/{id}");
    b.p('orderId', () => input.orderId, '{orderId}', false);
    b.p('itemId', () => input.itemId, '{itemId}', false);
    b.p('id', () => input.id, '{id}', false);
    let body;
    b.m("DELETE")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_DownloadOrdersCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/orders/download");
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetBulkDownloadHistoryCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/files/download/all");
    const query = map({
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetCommentsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/comments/{taxonomyId+}");
    b.p('taxonomyId', () => input.taxonomyId, '{taxonomyId+}', true);
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetFilePresignedUrlCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/file/presignedurl/{fileId}");
    b.p('fileId', () => input.fileId, '{fileId}', false);
    const query = map({
        [_t]: [, input[_t]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetFilesCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/files/all");
    const query = map({
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetItemAttachmentCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/attachment/{attachmentId+}");
    b.p('attachmentId', () => input.attachmentId, '{attachmentId+}', true);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetItemAttachmentsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/attachments/{taxonomyId+}");
    b.p('taxonomyId', () => input.taxonomyId, '{taxonomyId+}', true);
    const query = map({
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetNotesCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/notes/{taxonomyId+}");
    b.p('taxonomyId', () => input.taxonomyId, '{taxonomyId+}', true);
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetOrderCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/order/{orderId+}");
    b.p('orderId', () => input.orderId, '{orderId+}', true);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetOrderItemsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/items");
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetOrderItemsDownloadCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/items/download");
    const query = map({
        [_t]: [, input[_t]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetOrders_AllCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/orders/all");
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetOrders_DirectsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/orders/directs");
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetOrders_MyCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/orders/my");
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetTicketCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/ticket/{ticketId+}");
    b.p('ticketId', () => input.ticketId, '{ticketId+}', true);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetTickets_AllCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/tickets/all");
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetTickets_DirectsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/tickets/directs");
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_GetTickets_MyCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/tickets/my");
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("GET")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_HeadOrders_DirectsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/orders/directs");
    const query = map({
        ...convertMap(input.filters),
        [_nT]: [, input[_nT]],
        [_pS]: [() => input.pageSize !== void 0, () => (input[_pS].toString())],
        [_oB]: [, input[_oB]],
    });
    let body;
    b.m("HEAD")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_PatchCommentCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/comments/{taxonomyId+}");
    b.p('taxonomyId', () => input.taxonomyId, '{taxonomyId+}', true);
    let body;
    body = JSON.stringify(take(input, {
        'commentText': [],
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_PatchNoteCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/notes/{taxonomyId+}");
    b.p('taxonomyId', () => input.taxonomyId, '{taxonomyId+}', true);
    let body;
    body = JSON.stringify(take(input, {
        'commentText': [],
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_PostBulkCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = map({}, isSerializableHeaderValue, {
        [_ct]: input[_cT] || 'application/octet-stream',
        [_xifn]: input[_fN],
        [_xiub]: input[_uB],
    });
    b.bp("/files/bulkupload");
    let body;
    if (input.uploadedFile !== undefined) {
        body = input.uploadedFile;
    }
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_PostCommentCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/comments/{taxonomyId+}");
    b.p('taxonomyId', () => input.taxonomyId, '{taxonomyId+}', true);
    const query = map({
        [_dR]: [() => input.dryRun !== void 0, () => (input[_dR].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'comment': [],
        'tags': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_PostItemAttachmentCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = map({}, isSerializableHeaderValue, {
        [_ct]: input[_cT] || 'application/octet-stream',
        [_xifn]: input[_fN],
        [_xiub]: input[_uB],
    });
    b.bp("/attachments/{taxonomyId+}");
    b.p('taxonomyId', () => input.taxonomyId, '{taxonomyId+}', true);
    let body;
    if (input.attachment !== undefined) {
        body = input.attachment;
    }
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_PostLineCommentCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/comments/line");
    const query = map({
        [_dR]: [() => input.dryRun !== void 0, () => (input[_dR].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'comment': [],
        'tags': _ => _json(_),
        'taxonomyId': [],
    }));
    b.m("POST")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_PostLineCommentBulkCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/comments/line/bulk");
    const query = map({
        [_dR]: [() => input.dryRun !== void 0, () => (input[_dR].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'comment': [],
        'tags': _ => _json(_),
        'taxonomyIds': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_PostNoteCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/notes/{taxonomyId+}");
    b.p('taxonomyId', () => input.taxonomyId, '{taxonomyId+}', true);
    const query = map({
        [_dR]: [() => input.dryRun !== void 0, () => (input[_dR].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'comment': [],
        'tags': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_ProcureOrderItemsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/items/{orderId+}");
    b.p('orderId', () => input.orderId, '{orderId+}', true);
    const query = map({
        [_dR]: [() => input.dryRun !== void 0, () => (input[_dR].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'assets': _ => se_ListOfProcureOrderByAsset(_, context),
    }));
    b.m("POST")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_RecallOrderCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/recall/order/{orderId+}");
    b.p('orderId', () => input.orderId, '{orderId+}', true);
    let body;
    body = JSON.stringify(take(input, {
        'assets': _ => se_ListRecallAssetByItem(_, context),
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_RecallOrdersCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/orders/recall");
    let body;
    body = JSON.stringify(take(input, {
        'orderIds': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_SubmitOrderCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/order");
    const query = map({
        [_dR]: [() => input.dryRun !== void 0, () => (input[_dR].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'acknowledgementAudit': _ => se_AcknowledgementAudit(_, context),
        'deliveryTo': _ => _json(_),
        'details': _ => se_Document(_, context),
        'items': _ => se_SubmitOrderItemsMap(_, context),
        'labels': _ => _json(_),
        'relatedTo': _ => _json(_),
        'requesterOverride': [],
    }));
    b.m("POST")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_UpdateItemDetailsCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/orders/{orderId}/items/{itemId}");
    b.p('orderId', () => input.orderId, '{orderId}', false);
    b.p('itemId', () => input.itemId, '{itemId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'details': _ => se_Document(_, context),
        'quantity': [],
        'status': [],
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_UpdateOrderStatusCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/order/{orderId+}");
    b.p('orderId', () => input.orderId, '{orderId+}', true);
    const query = map({
        [_dR]: [() => input.dryRun !== void 0, () => (input[_dR].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'assignedTo': [],
        'details': _ => se_Document(_, context),
        'status': [],
    }));
    b.m("PATCH")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const se_UpdateOrderStatusBatchCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/orders");
    let body;
    body = JSON.stringify(take(input, {
        'orders': _ => se_ListOfUpdateOneOrderStatus(_, context),
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_UpdateSubLineItemCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/orders/{orderId}/items/{itemId}/sublines/{id}");
    b.p('orderId', () => input.orderId, '{orderId}', false);
    b.p('itemId', () => input.itemId, '{itemId}', false);
    b.p('id', () => input.id, '{id}', false);
    let body;
    body = JSON.stringify(take(input, {
        'subLineItem': _ => se_OrderSubLineItem(_, context),
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_UpdateTicketStatusCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/ticket/{ticketId+}");
    b.p('ticketId', () => input.ticketId, '{ticketId+}', true);
    const query = map({
        [_dR]: [() => input.dryRun !== void 0, () => (input[_dR].toString())],
    });
    let body;
    body = JSON.stringify(take(input, {
        'status': [],
    }));
    b.m("PATCH")
        .h(headers)
        .q(query)
        .b(body);
    return b.build();
};
export const de_AddOrderLabelCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'acknowledgementAudit': _ => de_AcknowledgementAudit(_, context),
        'approvals': _ => de_ApprovalsList(_, context),
        'approver': _json,
        'assets': _ => de_ListOfAssets(_, context),
        'assignedTo': __expectString,
        'deliveryTo': _json,
        'details': _ => de_Document(_, context),
        'display': __expectString,
        'items': _ => de_ListOfOrderItem(_, context),
        'location': __expectString,
        'orderId': __expectString,
        'orderLabels': _ => de_OrderLabelStampList(_, context),
        'orderReference': __expectString,
        'relations': _json,
        'requested': _ => de_ActionStamp(_, context),
        'requester': _json,
        'rulesEvents': _ => de_RulesEventsList(_, context),
        'status': __expectString,
        'statusHistory': _ => de_OrderStatusStampList(_, context),
        'total': _ => de_Amount(_, context),
        'uploadInformation': _ => de_Document(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_AddSubLineItemCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'carrier': __expectString,
        'deliveryDate': _ => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'id': __expectString,
        'poNumber': __expectString,
        'prNumber': __expectString,
        'quantityDelivered': __expectInt32,
        'status': __expectString,
        'trackingNumber': __expectString,
        'vendor': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_BulkProcessSubLinesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'subLinesError': _ => de_ListOfSubLinePerOrderItemsResult(_, context),
        'subLinesOk': _ => de_ListOfSubLinePerOrderItems(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_CutTicketCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'assigned': _ => de_ActionStamp(_, context),
        'assignedTo': __expectString,
        'created': _ => de_ActionStamp(_, context),
        'isResponseRequired': __expectBoolean,
        'lastCommentInfo': _ => de_ActionStamp(_, context),
        'relatedTo': __expectString,
        'resolved': _ => de_ActionStamp(_, context),
        'status': __expectString,
        'ticketId': __expectString,
        'type': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_DeleteCommentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
export const de_DeleteItemAttachmentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
export const de_DeleteNoteCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
export const de_DeleteSubLineItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
export const de_DownloadOrdersCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'fileContent': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetBulkDownloadHistoryCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'files': _ => de_BulkDownloadHistoryList(_, context),
        'nextToken': __expectString,
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetCommentsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'comments': _ => de_ListOfComments(_, context),
        'filters': _json,
        'nextToken': __expectString,
        'pageSize': __expectInt32,
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetFilePresignedUrlCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'preSignedUrl': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetFilesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'files': _ => de_BulkUploadHistoryList(_, context),
        'nextToken': __expectString,
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetItemAttachmentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'preSignedUrl': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetItemAttachmentsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'attachments': _ => de_ListOfAttachments(_, context),
        'nextToken': __expectString,
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetNotesCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'comments': _ => de_ListOfComments(_, context),
        'filters': _json,
        'nextToken': __expectString,
        'pageSize': __expectInt32,
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetOrderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'acknowledgementAudit': _ => de_AcknowledgementAudit(_, context),
        'approvals': _ => de_ApprovalsList(_, context),
        'approver': _json,
        'assets': _ => de_ListOfAssets(_, context),
        'assignedTo': __expectString,
        'deliveryTo': _json,
        'details': _ => de_Document(_, context),
        'display': __expectString,
        'items': _ => de_ListOfOrderItem(_, context),
        'location': __expectString,
        'orderId': __expectString,
        'orderLabels': _ => de_OrderLabelStampList(_, context),
        'orderReference': __expectString,
        'relations': _json,
        'requested': _ => de_ActionStamp(_, context),
        'requester': _json,
        'rulesEvents': _ => de_RulesEventsList(_, context),
        'status': __expectString,
        'statusHistory': _ => de_OrderStatusStampList(_, context),
        'total': _ => de_Amount(_, context),
        'uploadInformation': _ => de_Document(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetOrderItemsCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'filters': _json,
        'items': _ => de_ListOfFlatOrderItems(_, context),
        'nextToken': __expectString,
        'pageSize': __expectInt32,
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetOrderItemsDownloadCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'fileContent': __expectString,
        'fileName': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetOrders_AllCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'filters': _json,
        'nextToken': __expectString,
        'orders': _ => de_OrdersList(_, context),
        'pageSize': __expectInt32,
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetOrders_DirectsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'filters': _json,
        'nextToken': __expectString,
        'orders': _ => de_OrdersList(_, context),
        'pageSize': __expectInt32,
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetOrders_MyCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'filters': _json,
        'nextToken': __expectString,
        'orders': _ => de_OrdersList(_, context),
        'pageSize': __expectInt32,
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetTicketCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'assigned': _ => de_ActionStamp(_, context),
        'assignedTo': __expectString,
        'created': _ => de_ActionStamp(_, context),
        'isResponseRequired': __expectBoolean,
        'lastCommentInfo': _ => de_ActionStamp(_, context),
        'relatedTo': __expectString,
        'resolved': _ => de_ActionStamp(_, context),
        'status': __expectString,
        'ticketId': __expectString,
        'type': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetTickets_AllCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'filters': _json,
        'nextToken': __expectString,
        'pageSize': __expectInt32,
        'tickets': _ => de_ListOfTickets(_, context),
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    map(contents, {
        code: [, output.statusCode]
    });
    return contents;
};
export const de_GetTickets_DirectsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'filters': _json,
        'nextToken': __expectString,
        'pageSize': __expectInt32,
        'tickets': _ => de_ListOfTickets(_, context),
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    map(contents, {
        code: [, output.statusCode]
    });
    return contents;
};
export const de_GetTickets_MyCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'filters': _json,
        'nextToken': __expectString,
        'pageSize': __expectInt32,
        'tickets': _ => de_ListOfTickets(_, context),
        'totalResults': __expectInt32,
    });
    Object.assign(contents, doc);
    map(contents, {
        code: [, output.statusCode]
    });
    return contents;
};
export const de_HeadOrders_DirectsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
        [_tR]: [() => void 0 !== output.headers[_xtr], () => __strictParseInt32(output.headers[_xtr])],
    });
    await collectBody(output.body, context);
    return contents;
};
export const de_PatchCommentCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'comment': _ => de_Comment(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_PatchNoteCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'comment': _ => de_Comment(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_PostBulkCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'fileId': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_PostCommentCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'comment': __expectString,
        'commentId': __expectString,
        'posted': _ => de_ActionStamp(_, context),
        'read': _ => de_ActionStamp(_, context),
        'relatedTo': __expectString,
        'tags': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_PostItemAttachmentCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'attachmentId': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_PostLineCommentCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'comment': __expectString,
        'commentId': __expectString,
        'posted': _ => de_ActionStamp(_, context),
        'read': _ => de_ActionStamp(_, context),
        'relatedTo': __expectString,
        'tags': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_PostLineCommentBulkCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'comments': _ => de_ListOfComments(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_PostNoteCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'comment': __expectString,
        'commentId': __expectString,
        'posted': _ => de_ActionStamp(_, context),
        'read': _ => de_ActionStamp(_, context),
        'relatedTo': __expectString,
        'tags': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_ProcureOrderItemsCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'assets': _ => de_ListOfAssets(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_RecallOrderCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'acknowledgementAudit': _ => de_AcknowledgementAudit(_, context),
        'approvals': _ => de_ApprovalsList(_, context),
        'approver': _json,
        'assets': _ => de_ListOfAssets(_, context),
        'assignedTo': __expectString,
        'deliveryTo': _json,
        'details': _ => de_Document(_, context),
        'display': __expectString,
        'items': _ => de_ListOfOrderItem(_, context),
        'location': __expectString,
        'orderId': __expectString,
        'orderLabels': _ => de_OrderLabelStampList(_, context),
        'orderReference': __expectString,
        'relations': _json,
        'requested': _ => de_ActionStamp(_, context),
        'requester': _json,
        'rulesEvents': _ => de_RulesEventsList(_, context),
        'status': __expectString,
        'statusHistory': _ => de_OrderStatusStampList(_, context),
        'total': _ => de_Amount(_, context),
        'uploadInformation': _ => de_Document(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_RecallOrdersCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'orders': _ => de_ListOfUpdateOneOrderStatus(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_SubmitOrderCommand = async (output, context) => {
    if (output.statusCode !== 201 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'acknowledgementAudit': _ => de_AcknowledgementAudit(_, context),
        'approver': _json,
        'assets': _ => de_ListOfAssets(_, context),
        'assignedTo': __expectString,
        'deliveryTo': _json,
        'details': _ => de_Document(_, context),
        'display': __expectString,
        'items': _ => de_ListOfOrderItem(_, context),
        'location': __expectString,
        'orderId': __expectString,
        'orderLabels': _ => de_OrderLabelStampList(_, context),
        'orderReference': __expectString,
        'relations': _json,
        'requested': _ => de_ActionStamp(_, context),
        'requester': _json,
        'rulesEvents': _ => de_RulesEventsList(_, context),
        'status': __expectString,
        'statusHistory': _ => de_OrderStatusStampList(_, context),
        'total': _ => de_Amount(_, context),
        'uploadInformation': _ => de_Document(_, context),
    });
    Object.assign(contents, doc);
    map(contents, {
        httpResponseCode: [, output.statusCode]
    });
    return contents;
};
export const de_UpdateItemDetailsCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'acknowledgementAudit': _ => de_AcknowledgementAudit(_, context),
        'approvals': _ => de_ApprovalsList(_, context),
        'approver': _json,
        'assets': _ => de_ListOfAssets(_, context),
        'assignedTo': __expectString,
        'deliveryTo': _json,
        'details': _ => de_Document(_, context),
        'display': __expectString,
        'items': _ => de_ListOfOrderItem(_, context),
        'location': __expectString,
        'orderId': __expectString,
        'orderLabels': _ => de_OrderLabelStampList(_, context),
        'orderReference': __expectString,
        'relations': _json,
        'requested': _ => de_ActionStamp(_, context),
        'requester': _json,
        'rulesEvents': _ => de_RulesEventsList(_, context),
        'status': __expectString,
        'statusHistory': _ => de_OrderStatusStampList(_, context),
        'total': _ => de_Amount(_, context),
        'uploadInformation': _ => de_Document(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_UpdateOrderStatusCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'acknowledgementAudit': _ => de_AcknowledgementAudit(_, context),
        'approvals': _ => de_ApprovalsList(_, context),
        'approver': _json,
        'assets': _ => de_ListOfAssets(_, context),
        'assignedTo': __expectString,
        'deliveryTo': _json,
        'details': _ => de_Document(_, context),
        'display': __expectString,
        'items': _ => de_ListOfOrderItem(_, context),
        'location': __expectString,
        'orderId': __expectString,
        'orderLabels': _ => de_OrderLabelStampList(_, context),
        'orderReference': __expectString,
        'relations': _json,
        'requested': _ => de_ActionStamp(_, context),
        'requester': _json,
        'rulesEvents': _ => de_RulesEventsList(_, context),
        'status': __expectString,
        'statusHistory': _ => de_OrderStatusStampList(_, context),
        'total': _ => de_Amount(_, context),
        'uploadInformation': _ => de_Document(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_UpdateOrderStatusBatchCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'orders': _ => de_ListOfUpdateOneOrderStatus(_, context),
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_UpdateSubLineItemCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'carrier': __expectString,
        'deliveryDate': _ => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'id': __expectString,
        'poNumber': __expectString,
        'prNumber': __expectString,
        'quantityDelivered': __expectInt32,
        'status': __expectString,
        'trackingNumber': __expectString,
        'vendor': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_UpdateTicketStatusCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'assigned': _ => de_ActionStamp(_, context),
        'assignedTo': __expectString,
        'created': _ => de_ActionStamp(_, context),
        'isResponseRequired': __expectBoolean,
        'lastCommentInfo': _ => de_ActionStamp(_, context),
        'relatedTo': __expectString,
        'resolved': _ => de_ActionStamp(_, context),
        'status': __expectString,
        'ticketId': __expectString,
        'type': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
const de_CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadRequestException":
        case "com.a2z.it.ams#BadRequestException":
            throw await de_BadRequestExceptionRes(parsedOutput, context);
        case "ForbiddenException":
        case "com.a2z.it.ams#ForbiddenException":
            throw await de_ForbiddenExceptionRes(parsedOutput, context);
        case "InternalServerException":
        case "com.a2z.it.ams#InternalServerException":
            throw await de_InternalServerExceptionRes(parsedOutput, context);
        case "NotFoundException":
        case "com.a2z.it.ams#NotFoundException":
            throw await de_NotFoundExceptionRes(parsedOutput, context);
        case "ThrottlingError":
        case "com.a2z.it.ams#ThrottlingError":
            throw await de_ThrottlingErrorRes(parsedOutput, context);
        case "UnauthorizedException":
        case "com.a2z.it.ams#UnauthorizedException":
            throw await de_UnauthorizedExceptionRes(parsedOutput, context);
        case "OUIDependencyException":
        case "com.a2z.it.ams#OUIDependencyException":
            throw await de_OUIDependencyExceptionRes(parsedOutput, context);
        case "BRASSDependencyException":
        case "com.a2z.it.ams#BRASSDependencyException":
            throw await de_BRASSDependencyExceptionRes(parsedOutput, context);
        case "CatalogicalDependencyException":
        case "com.a2z.it.ams#CatalogicalDependencyException":
            throw await de_CatalogicalDependencyExceptionRes(parsedOutput, context);
        case "ExpectationFailedException":
        case "com.a2z.it.ams#ExpectationFailedException":
            throw await de_ExpectationFailedExceptionRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return throwDefaultError({
                output,
                parsedBody,
                errorCode
            });
    }
};
const throwDefaultError = withBaseException(__BaseException);
const de_BadRequestExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new BadRequestException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_BRASSDependencyExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
        'originalStatusCode': __expectInt32,
    });
    Object.assign(contents, doc);
    const exception = new BRASSDependencyException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_CatalogicalDependencyExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
        'originalStatusCode': __expectInt32,
    });
    Object.assign(contents, doc);
    const exception = new CatalogicalDependencyException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_ExpectationFailedExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new ExpectationFailedException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_ForbiddenExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new ForbiddenException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_InternalServerExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new InternalServerException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_NotFoundExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new NotFoundException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_OUIDependencyExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
        'originalStatusCode': __expectInt32,
    });
    Object.assign(contents, doc);
    const exception = new OUIDependencyException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_ThrottlingErrorRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new ThrottlingError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_UnauthorizedExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new UnauthorizedException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const se_AcknowledgementAudit = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_AcknowledgementAuditEntry(entry, context);
    });
};
const se_AcknowledgementAuditEntry = (input, context) => {
    return take(input, {
        'acknowledged': [],
        'by': [],
        'on': __serializeDateTime,
        'policyName': [],
    });
};
const se_Amount = (input, context) => {
    return take(input, {
        'amount': __serializeFloat,
        'currency': [],
    });
};
const se_ListOfProcureOrderByAsset = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_ProcureOrderByAsset(entry, context);
    });
};
const se_ListOfSubLinePerOrderItems = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_SubLinePerOrderItem(entry, context);
    });
};
const se_ListOfUpdateOneOrderStatus = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_UpdateOneOrderStatus(entry, context);
    });
};
const se_ListRecallAssetByItem = (input, context) => {
    return input.filter((e) => e != null).map(entry => {
        return se_RecallAssetByItem(entry, context);
    });
};
const se_OrderSubLineItem = (input, context) => {
    return take(input, {
        'carrier': [],
        'deliveryDate': __serializeDateTime,
        'id': [],
        'poNumber': [],
        'prNumber': [],
        'quantityDelivered': [],
        'status': [],
        'trackingNumber': [],
        'vendor': [],
    });
};
const se_ProcureOrderByAsset = (input, context) => {
    return take(input, {
        'assetGuid': [],
        'details': _ => se_Document(_, context),
        'itemId': [],
        'price': _ => se_Amount(_, context),
    });
};
const se_RecallAssetByItem = (input, context) => {
    return take(input, {
        'assetId': [],
        'details': _ => se_Document(_, context),
        'itemId': [],
    });
};
const se_SubLinePerOrderItem = (input, context) => {
    return take(input, {
        'itemId': [],
        'orderId': [],
        'subLineItem': _ => se_OrderSubLineItem(_, context),
    });
};
const se_SubmitOrderItem = (input, context) => {
    return take(input, {
        'deliveredQuantity': [],
        'details': _ => se_Document(_, context),
        'quantity': [],
        'status': [],
    });
};
const se_SubmitOrderItemsMap = (input, context) => {
    return Object.entries(input).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = se_SubmitOrderItem(value, context);
        return acc;
    }, {});
};
const se_UpdateOneOrderStatus = (input, context) => {
    return take(input, {
        'assignedTo': [],
        'details': _ => se_Document(_, context),
        'dryRun': [],
        'orderId': [],
        'status': [],
    });
};
const se_Document = (input, context) => {
    return input;
};
const de_AcknowledgementAudit = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_AcknowledgementAuditEntry(entry, context);
    });
    return retVal;
};
const de_AcknowledgementAuditEntry = (output, context) => {
    return take(output, {
        'acknowledged': __expectBoolean,
        'by': __expectString,
        'on': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'policyName': __expectString,
    });
};
const de_ActionStamp = (output, context) => {
    return take(output, {
        'by': __expectString,
        'on': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'via': __expectString,
    });
};
const de_Amount = (output, context) => {
    return take(output, {
        'amount': __limitedParseDouble,
        'currency': __expectString,
    });
};
const de_Approval = (output, context) => {
    return take(output, {
        'approvalId': __expectString,
        'history': (_) => de_ApprovalStatusStampList(_, context),
        'status': __expectString,
        'templateId': __expectString,
        'title': __expectString,
    });
};
const de_ApprovalsList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_Approval(entry, context);
    });
    return retVal;
};
const de_ApprovalStatusStamp = (output, context) => {
    return take(output, {
        'by': __expectString,
        'on': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'status': __expectString,
        'via': __expectString,
    });
};
const de_ApprovalStatusStampList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_ApprovalStatusStamp(entry, context);
    });
    return retVal;
};
const de_Asset = (output, context) => {
    return take(output, {
        'assetId': __expectString,
        'details': (_) => de_Document(_, context),
        'orderId': __expectString,
        'price': (_) => de_Amount(_, context),
        'procured': (_) => de_ActionStamp(_, context),
    });
};
const de_Attachment = (output, context) => {
    return take(output, {
        'attachmentId': __expectString,
        'fileName': __expectString,
        'relatedTo': __expectString,
        'uploadedStamp': (_) => de_ActionStamp(_, context),
    });
};
const de_BulkDownloadHistory = (output, context) => {
    return take(output, {
        'fileId': __expectString,
        'fileName': __expectString,
        'stamp': (_) => de_ActionStamp(_, context),
    });
};
const de_BulkDownloadHistoryList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_BulkDownloadHistory(entry, context);
    });
    return retVal;
};
const de_BulkUploadHistory = (output, context) => {
    return take(output, {
        'details': __expectString,
        'fileId': __expectString,
        'fileName': __expectString,
        'originalS3FileUrl': __expectString,
        'status': __expectString,
        'uploadedBy': __expectString,
        'uploadedDate': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
    });
};
const de_BulkUploadHistoryList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_BulkUploadHistory(entry, context);
    });
    return retVal;
};
const de_Comment = (output, context) => {
    return take(output, {
        'comment': __expectString,
        'commentId': __expectString,
        'posted': (_) => de_ActionStamp(_, context),
        'read': (_) => de_ActionStamp(_, context),
        'relatedTo': __expectString,
        'tags': _json,
    });
};
const de_FlatOrderItems = (output, context) => {
    return take(output, {
        'acknowledgementAudit': (_) => de_AcknowledgementAudit(_, context),
        'approver': _json,
        'assets': (_) => de_ListOfAssets(_, context),
        'assignedTo': __expectString,
        'deliveryTo': _json,
        'details': (_) => de_Document(_, context),
        'display': __expectString,
        'item': (_) => de_OrderItem(_, context),
        'itemIndex': __expectInt32,
        'location': __expectString,
        'mapping': (_) => de_Document(_, context),
        'orderId': __expectString,
        'orderLabels': (_) => de_OrderLabelStampList(_, context),
        'orderReference': __expectString,
        'relations': _json,
        'requested': (_) => de_ActionStamp(_, context),
        'requester': _json,
        'rulesEvents': (_) => de_RulesEventsList(_, context),
        'status': __expectString,
        'statusHistory': (_) => de_OrderStatusStampList(_, context),
        'total': (_) => de_Amount(_, context),
        'uploadInformation': (_) => de_Document(_, context),
    });
};
const de_ListOfAssets = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_Asset(entry, context);
    });
    return retVal;
};
const de_ListOfAttachments = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_Attachment(entry, context);
    });
    return retVal;
};
const de_ListOfComments = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_Comment(entry, context);
    });
    return retVal;
};
const de_ListOfFlatOrderItems = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_FlatOrderItems(entry, context);
    });
    return retVal;
};
const de_ListOfOrderItem = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_OrderItem(entry, context);
    });
    return retVal;
};
const de_ListOfSubLineItems = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_OrderSubLineItem(entry, context);
    });
    return retVal;
};
const de_ListOfSubLinePerOrderItems = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_SubLinePerOrderItem(entry, context);
    });
    return retVal;
};
const de_ListOfSubLinePerOrderItemsResult = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_SubLinePerOrderItemResult(entry, context);
    });
    return retVal;
};
const de_ListOfTickets = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_Ticket(entry, context);
    });
    return retVal;
};
const de_ListOfUpdateOneOrderStatus = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_UpdateOneOrderStatus(entry, context);
    });
    return retVal;
};
const de_Order = (output, context) => {
    return take(output, {
        'acknowledgementAudit': (_) => de_AcknowledgementAudit(_, context),
        'approvals': (_) => de_ApprovalsList(_, context),
        'approver': _json,
        'assets': (_) => de_ListOfAssets(_, context),
        'assignedTo': __expectString,
        'deliveryTo': _json,
        'details': (_) => de_Document(_, context),
        'display': __expectString,
        'items': (_) => de_ListOfOrderItem(_, context),
        'location': __expectString,
        'orderId': __expectString,
        'orderLabels': (_) => de_OrderLabelStampList(_, context),
        'orderReference': __expectString,
        'relations': _json,
        'requested': (_) => de_ActionStamp(_, context),
        'requester': _json,
        'rulesEvents': (_) => de_RulesEventsList(_, context),
        'status': __expectString,
        'statusHistory': (_) => de_OrderStatusStampList(_, context),
        'total': (_) => de_Amount(_, context),
        'uploadInformation': (_) => de_Document(_, context),
    });
};
const de_OrderItem = (output, context) => {
    return take(output, {
        'assets': _json,
        'deliveredQuantity': __expectInt32,
        'details': (_) => de_Document(_, context),
        'itemId': __expectString,
        'itemInformation': (_) => de_Document(_, context),
        'orderWorkflow': __expectString,
        'price': (_) => de_Amount(_, context),
        'quantity': __expectInt32,
        'relatedTickets': _json,
        'status': __expectString,
        'subLineItems': (_) => de_ListOfSubLineItems(_, context),
        'taxonomyId': __expectString,
    });
};
const de_OrderLabelStamp = (output, context) => {
    return take(output, {
        'by': __expectString,
        'description': __expectString,
        'label': __expectString,
        'on': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'via': __expectString,
    });
};
const de_OrderLabelStampList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_OrderLabelStamp(entry, context);
    });
    return retVal;
};
const de_OrdersList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_Order(entry, context);
    });
    return retVal;
};
const de_OrderStatusStamp = (output, context) => {
    return take(output, {
        'by': __expectString,
        'commentId': __expectString,
        'on': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'status': __expectString,
        'via': __expectString,
    });
};
const de_OrderStatusStampList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_OrderStatusStamp(entry, context);
    });
    return retVal;
};
const de_OrderSubLineItem = (output, context) => {
    return take(output, {
        'carrier': __expectString,
        'deliveryDate': (_) => __expectNonNull(__parseRfc3339DateTimeWithOffset(_)),
        'id': __expectString,
        'poNumber': __expectString,
        'prNumber': __expectString,
        'quantityDelivered': __expectInt32,
        'status': __expectString,
        'trackingNumber': __expectString,
        'vendor': __expectString,
    });
};
const de_RulesEvent = (output, context) => {
    return take(output, {
        'params': (_) => de_Document(_, context),
        'type': __expectString,
    });
};
const de_RulesEventsList = (output, context) => {
    const retVal = (output || []).filter((e) => e != null).map((entry) => {
        return de_RulesEvent(entry, context);
    });
    return retVal;
};
const de_SubLinePerOrderItem = (output, context) => {
    return take(output, {
        'itemId': __expectString,
        'orderId': __expectString,
        'subLineItem': (_) => de_OrderSubLineItem(_, context),
    });
};
const de_SubLinePerOrderItemResult = (output, context) => {
    return take(output, {
        'itemId': __expectString,
        'orderId': __expectString,
        'result': __expectString,
        'subLineItem': (_) => de_OrderSubLineItem(_, context),
    });
};
const de_Ticket = (output, context) => {
    return take(output, {
        'assigned': (_) => de_ActionStamp(_, context),
        'assignedTo': __expectString,
        'created': (_) => de_ActionStamp(_, context),
        'isResponseRequired': __expectBoolean,
        'lastCommentInfo': (_) => de_ActionStamp(_, context),
        'relatedTo': __expectString,
        'resolved': (_) => de_ActionStamp(_, context),
        'status': __expectString,
        'ticketId': __expectString,
        'type': __expectString,
    });
};
const de_UpdateOneOrderStatus = (output, context) => {
    return take(output, {
        'assignedTo': __expectString,
        'details': (_) => de_Document(_, context),
        'dryRun': __expectBoolean,
        'orderId': __expectString,
        'status': __expectString,
    });
};
const de_Document = (output, context) => {
    return output;
};
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
const collectBodyString = (streamBody, context) => collectBody(streamBody, context).then(body => context.utf8Encoder(body));
const isSerializableHeaderValue = (value) => value !== undefined &&
    value !== null &&
    value !== "" &&
    (!Object.getOwnPropertyNames(value).includes("length") ||
        value.length != 0) &&
    (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
const _cT = "contentType";
const _ct = "content-type";
const _dR = "dryRun";
const _fN = "fileName";
const _nT = "nextToken";
const _oB = "orderBy";
const _pS = "pageSize";
const _t = "type";
const _tR = "totalResults";
const _uB = "uploadedBy";
const _xifn = "x-ito-file-name";
const _xiub = "x-ito-uploaded-by";
const _xtr = "x-total-results";
